import { DefaultBaseObjectFormGroupMapper } from './default-base-object-form-group.mapper';
import { BaseObject } from '../_models/base-object';
import { hasNumericValue } from '../_utils/utils';
import { ProductTank } from '../_models/product-tank';

export abstract class BaseProductTankFormGroupMapper extends DefaultBaseObjectFormGroupMapper {
  override map(source: BaseObject, destination: BaseObject) {
    super.map(source, destination);
    const sourcePlainObject = source as ProductTank;
    const destinationInstance = destination as ProductTank;

    destinationInstance.isOptimizable = !!sourcePlainObject.isOptimizable;
    this.mapRatioVariables(sourcePlainObject, destinationInstance);
  }

  mapRatioVariables(source: ProductTank, destination: ProductTank) {
    for (let i = 0; i < source.distributionRatioVariables.length; i++) {
      const sourceValue = source.distributionRatioVariables[i].value;

      // eslint-disable-next-line max-len
      destination.distributionRatioVariables[i].value = hasNumericValue(sourceValue) ? +sourceValue : undefined;
    }
  }

  override ignoreForAutoMapping(key: string, source: BaseObject, destination: BaseObject): boolean {
    const sourcePlainObject = source as ProductTank;
    return (
      super.ignoreForAutoMapping(key, source, destination) ||
      source[key] === sourcePlainObject.distributionRatioVariables
    );
  }
}
